import { render, staticRenderFns } from "./SelfBiography.vue?vue&type=template&id=1cc4b4fd&scoped=true"
import script from "./SelfBiography.vue?vue&type=script&lang=js"
export * from "./SelfBiography.vue?vue&type=script&lang=js"
import style0 from "./SelfBiography.vue?vue&type=style&index=0&id=1cc4b4fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc4b4fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
